import {
    Accordion,
    createAccordion,
} from '@vfde-brix/ws10/accordion';
import { createComponentById } from '@vfde-brix/ws10/core';
import {
    ContentId,
    HtmlId,
} from '../enums/elementId';
import {
    trackAccordion,
    TrackingUIType,
} from '@vfde-sails/tracking';

/**
 * Creates a WS10 Accordion component.
 */
export const mountAccordion = (id: HtmlId, type = TrackingUIType.Accordion) =>
    createComponentById(createAccordion, id, {
        onToggle: ({ optOpen, stdHeadline }) => {
            optOpen && trackAccordion(stdHeadline, type);
        },
    });

/**
 * Closes all items inside an accordion
 *
 * @param accordion - Accordion to update
 */
export const closeAccordion = (accordion: Accordion) => {
    const { items } = accordion.getProperties();

    for (const item of items) {
        item.optOpen = false;
    }

    accordion.update({ items });
};

/**
 * Footnote accordion
 */
export const footnoteAccordion = (() => mountAccordion(ContentId.FootnoteAccordion, TrackingUIType.Footnote))();
